export const mapLayers = {
    LIGHT_MAP: 'mapbox://styles/onsolve/ckpxvspil1c7317qqx4q8ix1v',
    STREET_MAP: 'mapbox://styles/onsolve/cll6oscam00mj01p449wtafxd',
    SATELLITE_MAP: 'mapbox://styles/onsolve/cll6n0k4v00la01mf7ow0a6oh',
};
